"use strict";

angular.module('app.controllers.devices.dataPoint', []).// Controller Info Controller

// Controller for Device
// When we are in

controller("DatapointItemCtrl", ['$rootScope', '$filter', '$scope', 'f_User', 'scaleValueModal', 'deviceLogSettingsModal', 'statisticModal', 'controlledBySceneModal', '__DeviceLogSettings', 'API', 'datapointCustomConfigModal', '$q', '__Bundle', '$state', 'xCenterConfig',
    function ($rootScope, $filter, $scope, f_User, scaleValueModal, deviceLogSettingsModal, statisticModal, controlledBySceneModal, __DeviceLogSettings, API, datapointCustomConfigModal, $q, __Bundle) {


        $scope.init = function () {
            $scope.rootScope = $rootScope;
            // $scope.MS = MasterService;
            $scope.User = f_User;
            console.debug('datapoint-item.js-init');
        }


        $scope.setValue = function (DP, value) {
            console.debug('datapoint-item.js-setValue');
            console.debug(DP);
            DP.DatapointValue.Value = value;
            $scope.writeValue({params: DP, value: value});
        };


        $scope.writeValue = function (arg) {
            console.debug('datapoint-item.js-writeValue');
            var Datapoint = arg.params;

            if (Datapoint.$UI == undefined) {
                Datapoint.$UI = {};
            }
            if (Datapoint.$UI.lastSaveValue == undefined) {
                Datapoint.$UI.lastSaveValue = Datapoint.DatapointValue.Value;
            }
            if (arg.withButtons) {
                $scope.$evalAsync(function() {

                    Datapoint.$UI.Buttons = true;
                    Datapoint.$UI.$tempValue = arg.value;
                    // we need thits to resolve it later on
                    // So Slider will catch refresh events
                    Datapoint.$UI.$tempPromise = arg.promise;
                });

            } else {
                console.log(Datapoint);
                Datapoint.setValue(arg.value);
                Datapoint.$UI.loading = true;

                Datapoint.DatapointValue.$save().$then(function () {

                    Datapoint.$UI.lastSaveValue = arg.value;
                    Datapoint.$UI.loading = false;
                    Datapoint.$UI.Buttons = false;
                    if($scope.callbacks && $scope.callbacks.onWrite){

                        $scope.callbacks.onWrite(
                            Datapoint
                        );
                    }

                    if (arg.promise) {
                        arg.promise.resolve( arg.value );
                    }

                })
            }
        }


        $scope.writeValueByButton = function (Datapoint) {
            Datapoint.setValue(Datapoint.$UI.$tempValue);
            console.log('Trace:datapoint-item.js-writeValueByButton');
            // Datapoint.DatapointValue.Value = ;
            Datapoint.$UI.loading = true;
            Datapoint.DatapointValue.$save().$then(function () {
                if($scope.callbacks && $scope.callbacks.onWrite){

                    $scope.callbacks.onWrite(
                        Datapoint
                    );
                }

                Datapoint.$UI.loading = false;
                Datapoint.$UI.lastSaveValue = Datapoint.$UI.$tempValue;
                Datapoint.$UI.$tempPromise.resolve( Datapoint.$UI.$tempValue );

                delete Datapoint.$UI.$tempValue;
                delete Datapoint.$UI.Buttons;

                if (inputElement !== undefined && (inputElement === 'input' || inputElement === 'colorpicker')) {
                    $scope.$broadcast('saveInput');
                }
            })
        }
        $scope.resetValueByButton = function (Datapoint, inputElement) {
            console.log('Trace:datapoint-item.js-resetValueByButton');
            //  0;
            Datapoint.$UI.$tempPromise.resolve( Datapoint.$UI.lastSaveValue );
            Datapoint.setValue( Datapoint.$UI.lastSaveValue  );

            delete Datapoint.$UI.$tempValue;
            delete Datapoint.$UI.lastSaveValue;
            delete Datapoint.$UI.Buttons;

            if (inputElement !== undefined && (inputElement === 'input' || inputElement === 'colorpicker')) {
                $scope.$broadcast('resetInput');
            }
        };

        $scope.showScenesForDevice = function (Device, Datapoint) {
            if(!Device){
                Device = {DeviceId:Datapoint.DatapointValue.DeviceId};
            }

            controlledBySceneModal({Device: Device, Datapoint: Datapoint});
        }

        $scope.setLogSettings = function (Device, Datapoint) {
            console.warn('This is handled by directive d_loggingbutton');
            return;
            var a = {
                "DeviceId": Device.DeviceId
            };
            __DeviceLogSettings.$get(a).$then(function (data) {
                Device.LogSettings = data;


                var point = ( $filter('filter')(Device.LogSettings.DatapointsToLog, {DatapointValue: {DatapointConfigId: Datapoint.DatapointConfig.DatapointConfigId}}) );

                var dp;
                if (point && point.length > 0) {
                    dp = point[0];

                } else {
                    dp = {
                        DatapointValue: Datapoint.DatapointValue
                    };
                    var newLogSettings = true;
                    console.log('NEW');
                }
                var params = {

                    "Title": Device.Name + ' ' + Datapoint.DatapointConfig.DisplayName
                };
                deviceLogSettingsModal(Device.LogSettings, dp, params).then(function (modal) {
                    modal.close.then(function (data) {
                        if (data) {
                            // Save Log Settings
                            console.log(data);
                            var LogSettings = {
                                LoggingServerEnabled: data.LoggingServerEnabled,
                                LoggingLocalEnabled: data.LoggingLocalEnabled,
                                StatisticLoggingEnabled: data.StatisticLoggingEnabled,
                                ReadInterval: data.ReadInterval,
                                Hysteresis: data.Hysteresis,
                                DatapointValue: data.DatapointValue

                            };
                            //data

                            if (newLogSettings) {
                                Device.LogSettings.DatapointsToLog.push(LogSettings);
                            } else {
                                // Find Datapoint
                                var point = ( $filter('filter')(Device.LogSettings.DatapointsToLog, {DatapointValue: {DatapointConfigId: Datapoint.DatapointConfig.DatapointConfigId}}) );
                                var i = Device.LogSettings.DatapointsToLog.indexOf(point[0]);
                                Device.LogSettings.DatapointsToLog[i] = LogSettings;
                            }
                            Device.LogSettings.$save().$then(function () {
                                Datapoint.DatapointValue.$readValue().$then(function () {
                                    Datapoint.setReadFlags();
                                });

                            });
                        } else {
                            // Nothin to do
                        }
                    });
                })
            });
        };

        function updateCurrentBundle(Bundle) {
            let _API = new API();
            let o = {
                'DeviceId': $scope.Device.DeviceId,
                'ParentMenuEntryId': $scope.$parent.Datapoint.Config.MenuEntryId,
                'WithDetails': false
            };
            _API.Menu.GetChildEntries(o).$promise
            .then(function (childEntries) {
                let newBundles = __Bundle.$collection();
                for (let i = 0; i < childEntries.Bundles.length; i++) {
                    // Initialize every Bundle (and so Datapoint, Value + config)
                    // And Add to Bundle Collection
                    /* Update only actually changed bundle, discard die others. */
                    if (childEntries.Bundles[i].DatapointBundleId === Bundle.DatapointBundleId) {
                        let a = __Bundle.$buildRaw(childEntries.Bundles[i]);
                        a.$dispatch('build');
                        newBundles.$add(a);
                        /* Copy newly changed properties from server into the existing bundle. */
                        Object.assign(Bundle, newBundles[0]);
                        break;
                    }
                }
            });
        }

        $scope.isAdmin = () => {
            return f_User.getUserLevel() >= 40;
        };

        $scope.openSettings = function (Bundle) {
            var Datapoints = angular.copy(Bundle.$UI.configValues);
            scaleValueModal(Datapoints, 'DATAPOINT_Modal_Settings').then(function (modal) {
                modal.close.then(function (data) {
                    console.log(data);
                    if (data) {
                        // Save Datapoint;
                        let promisses = [];
                        for (var i = 0; i < data.length; i++) {
                            // Todo: Optimize with new $collection.$save(); // One Call
                            /* __DatapointValue.$buildRaw(_.each(data,function(item){
                             return __DatapointValue.$buildRaw(item);
                             })).$saveCollection();*/
                             promisses.push(data[i].DatapointValue.$save().$asPromise());
                        }
                        $q.all(promisses)
                        .then(function() {
                            /* Wait until all datapoint values are saved to the server. */
                            updateCurrentBundle(Bundle);
                        });
                        // Bundle.setBundleVars();
                    }
                })
            })
        }

        $scope.openCustomSettingsFromDatapoint = (Datapoint) => {
            const _API = new API();
            const o = {
                'DeviceId': Datapoint.DatapointValue.DeviceId,
                'ConfigIds': [Datapoint.DatapointConfig.DatapointConfigId]
            };
            _API.Menu.GetBundlesByConfigs(o).$promise
            .then(function (childEntries) {
                let bundles = __Bundle.$collection();
                for (var i = 0; i < childEntries.length; i++) {
                    // Initialize every Bundle (and so Datapoint, Value + config)
                    // And Add to Bundle Collection
                    var a = __Bundle.$buildRaw(childEntries[i]);
                    a.$dispatch('build');
                    bundles.$add(a);
                }

                $scope.Datapoint = Datapoint;
                $scope.openCustomSettings(bundles[0]);
            });
        }

        $scope.openCustomSettings = function (Bundle) {
            var dp = Bundle.Datapoints.filter(function(value) {
                return areGuidsEqual(value.Config.DatapointConfigId, $scope.Datapoint.Config.DatapointConfigId);
            });
            if (Array.isArray(dp) && dp.length > 0) {
                var dpCopy = angular.copy(dp[0]);

                replaceDatapointTypeInConfigs(dpCopy);

                datapointCustomConfigModal(dpCopy, 'DATAPOINT_Modal_CustomConfigSettings').then(function (modal) {
                    modal.close.then(function (retVal) {
                        var dpConfig = retVal.dpConfig;
                        var revertHappened = retVal.revertHappened;

                        if (!dpConfig) {
                            /* Normal close, do nothing */
                            return;
                        }
                        if (revertHappened) {
                            /* The custom config is already deleted, update values in original dataset from default */
                            if (dp[0].Config) {
                                for (var invalidConfig in dpConfig) {
                                    if (dpConfig.hasOwnProperty(invalidConfig)) {
                                        if (invalidConfig === '$type') continue;

                                        dp[0].Config[invalidConfig] = dp[0].DatapointConfig[invalidConfig];
                                    }
                                }
                            }
                        } else {
                            /* New custom config saved, update values in original dataset */
                            for (var newConfig in dpConfig) {
                                if (dpConfig.hasOwnProperty(newConfig)) {
                                    if (newConfig === '$type') continue;

                                    dp[0].Config[newConfig] = dpConfig[newConfig];
                                }
                            }
                        }
                        Bundle.$dispatch('refresh-values');
                    });
                });
            }
        };

        function areGuidsEqual(guidA, guidB) {
            if(guidA.replace(/[{}]/g, "").toLowerCase() === guidB.replace(/[{}]/g, "").toLowerCase()) {
                return true;
            }
            return false;
        }

        function replaceDatapointTypeInConfigs(dp) {
            if (dp.Config !== undefined) {
                dp.Config = angular.merge({'$type': dp.Config._type.replace('DatapointConfig`1', 'CustomDatapointConfig`1')}, dp.Config);
                delete dp.Config._type;
            }

            dp.DatapointConfig = angular.merge({'$type': dp.DatapointConfig._type.replace('DatapointConfig`1', 'CustomDatapointConfig`1')}, dp.DatapointConfig);
            delete dp.DatapointConfig._type;
        }

        $scope.editScaleValue = function (Bundle) {
            var Datapoints = angular.copy(Bundle.$UI.configValues);
            scaleValueModal(Datapoints).then(function (modal) {
                modal.close.then(function (data) {
                    console.log(data);
                    if (data) {
                        // Save Datapoint;
                        for (var i = 0; i < data.length; i++) {
                            data[i].DatapointValue.$save();
                            Bundle.$dispatch('refresh-values');
                        }
                    }
                });
            });
        };
        $scope.showStatisticForDatapoint = function (b) {
            var n = [
                {
                    'DeviceId': b.DatapointValue.DeviceId,
                    'DatapointConfigId': b.Config.DatapointConfigId,
                    "DisplayName": b.Config.DisplayName,
                    "Config": b.Config
                }
            ];
            var statisticObject = {
                "FromUTC": moment().startOf('day').utc(),
                "ToUTC": moment().endOf('day').add({'hour': 1}).utc(),
                "Datapoints": n,
                "Period": 1
            };
            statisticModal(statisticObject);
        };

        $scope.hasStatisticEnabled = function (Device, Datapoint) {
            /* Function still used to check for the StatisticButton on the left of DatapointRow */
            if (
                (Device.$UI.LoggingEnabledByUserlevel && Datapoint.StatisticEnabled )
            ) {
                return true;
            }


            return false;
        };

        $scope.hasLoggingEnabled = function (Device, Datapoint) {
            console.log('Trace:datapoint-item.js-hasLoggingEnabled');
            console.warn('hasLoggingEnabled: This is handled by d_loggingButton');
            if(!Device.LogSettings){ return ''; }
            if(!Device.LogSettings.DatapointsToLog){ return ''; }

            var point = ( $filter('filter')(Device.LogSettings.DatapointsToLog, {DatapointValue: {DatapointConfigId: Datapoint.DatapointConfig.DatapointConfigId}}) );
            if (point.length > 0) {
                if (point[0].LoggingLocalEnabled || point[0].LoggingServerEnabled || point[0].StatisticLoggingEnabled) {
                    return 'green';
                }
            }
            return '';
        }

        $scope.init();

    }]);
